export const TITULO_FALHA = "Não foi possível concluir a operação";
export const TITULO_SEM_CONEXAO = "Sem conexão com o servidor";
export const TEXTO_SERVIDOR =
  "O servidor encontrou um erro interno. Tente de novo em alguns instantes. Se o erro continuar, informe o protocolo abaixo ao suporte.";
export const TEXTO_SEM_CONEXAO =
  "A requisição não chegou ao servidor. Confira sua conexão com a internet e tente de novo.";
export const MENSAGEM_PADRAO_NEGOCIO = "Não foi possível concluir a operação.";

function limpar(lista) {
  if (!Array.isArray(lista)) return [];
  return lista
    .filter((e) => e !== null && e !== undefined && String(e).trim() !== "")
    .map((e) => String(e));
}

function extrairMensagens(dados) {
  if (Array.isArray(dados)) return limpar(dados);
  if (typeof dados === "string") return limpar([dados]);
  if (dados && typeof dados === "object") {
    if (typeof dados.mensagem === "string") return limpar([dados.mensagem]);
    const erros = limpar(Array.isArray(dados.erros) ? dados.erros : []);
    if (erros.length > 0) return erros;
    if (typeof dados.msg === "string" && dados.msg.trim() !== "" && dados.msg !== "Erro") {
      return [dados.msg];
    }
  }
  return [];
}

// Agrupa o código de rastreio de 4 em 4 caracteres, separados por espaço.
export function formatarProtocolo(codigo) {
  if (!codigo) return "";
  return String(codigo).match(/.{1,4}/g).join(" ");
}

// Monta o que a janela de erro exibe a partir de tudo o que o ShowError recebe.
export function montarAvisoErro(dados) {
  const tipo =
    dados && typeof dados === "object" && !Array.isArray(dados) && dados.tipo
      ? dados.tipo
      : "negocio";

  if (tipo === "servidor") {
    const codigoRastreio = (dados && dados.codigoRastreio) || undefined;
    return {
      tipo,
      titulo: TITULO_FALHA,
      texto: TEXTO_SERVIDOR,
      mensagens: [],
      codigoRastreio,
      protocolo: codigoRastreio ? formatarProtocolo(codigoRastreio) : undefined,
    };
  }
  if (tipo === "comunicacao") {
    return {
      tipo,
      titulo: TITULO_SEM_CONEXAO,
      texto: TEXTO_SEM_CONEXAO,
      mensagens: [],
      codigoRastreio: undefined,
      protocolo: undefined,
    };
  }
  const mensagens = extrairMensagens(dados);
  return {
    tipo: "negocio",
    titulo: TITULO_FALHA,
    texto: null,
    mensagens: mensagens.length > 0 ? mensagens : [MENSAGEM_PADRAO_NEGOCIO],
    codigoRastreio: undefined,
    protocolo: undefined,
  };
}
